
window.addEventListener("load", () => {
  const d = document;
  /**
   * menu
   */
  const openMenu = d.getElementById("js-openMenu");
  const closeMenu = d.getElementById("js-closeMenu");
  const overlay = document.getElementById("js_overlay");
  const body = d.body;

  let scrollPos;
  openMenu.addEventListener("click", () => {
    scrollPos = pageYOffset;
    d.body.style.top = scrollPos * -1 + "px";
    d.body.classList.add("add-menuOpen");
  });
  closeMenu.addEventListener("click", () => {
    body.classList.remove("add-menuOpen");
    scrollTo(0, scrollPos);
  });
  if (overlay) {
    overlay.addEventListener("click", () => {
      body.classList.remove("add-menuOpen");
      scrollTo(0, scrollPos);
    });
  }
});
